import React, { useState, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { InputText, Label } from "../../../../components/Inputs";
import { notifyError } from "../../../../components/Utils";

const BasicPageContentForm = React.forwardRef(({ className, model }, ref) => {
  const initialModel = model || {};
  const [title, setTitle] = useState(initialModel.title || "");
  const [subtitle, setSubtitle] = useState(initialModel.subtitle || "");
  const [error, setError] = useState({ title: null });

  useImperativeHandle(ref, () => ({
    getModel: (noValidate) => {
      let isValid = true;
      const newError = { title: null };
      if (!title || title === "") {
        newError.title = true;
        isValid = false;
      }
      if (!noValidate && !isValid) {
        notifyError({
          summary: `Seiteninhalt`,
          detail: `Sie müssen einen Seitentitel angeben!`
        });
        setError(newError);
        return null;
      }
      return { title, subtitle };
    }
  }), [title, subtitle]);

  // console.log("BasicPageContentForm.render()", { title, subtitle, error });
  return (
    <div className={`${className} pad-big`}>
      <div className={`form-group-item ${error.title ? "error-group" : ""}`}>
        <Label htmlFor="title">{`Titel`}<span>*</span></Label>
        <InputText id="title" className="w3-block w3-border" value={title}
          onChange={(event) => setTitle(event.target.value)}/>
        {error.title && (<span className="w3-block w3-red">{error.title}</span>)}
      </div>
      <div className="form-group-item pad-top">
        <Label htmlFor="subtitle">{`Untertitel`}</Label>
        <InputText id="subtitle" className="w3-block w3-border" value={subtitle}
          onChange={(event) => setSubtitle(event.target.value)}/>
      </div>
    </div>
  );
});

BasicPageContentForm.displayName = "BasicPageContentForm";

BasicPageContentForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.object,
};

BasicPageContentForm.defaultProps = {
  className: "",
  model: { title: "", subtitle: "" },
};

export default BasicPageContentForm;
